module.exports = "/_next/static/images/Picture_MilanPolak@2x-90da22af68e7c9dabe2e1d0917693531.png";